import "./styles.css";
import Welcome from "./page/Welcome/Welcome";
import Comment from "./page/Comment/Comment";
import Home from "./page/Home/Home";
import NewComment from "./page/NewComment/NewComment";
import MyComment from "./page/MyComment/MyComment";
import ProfessorComment from "./page/Comment/ProfessorComment";
import ProfessorMyComment from "./page/MyComment/ProfessorMyComment";
import ProfessorNewComment from "./page/NewComment/ProfessorNewComment";
import Reflection from "./page/Reflection/Reflection";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { useState, useEffect, useLayoutEffect } from "react";
import { useDispatch } from "react-redux";
import { update } from "./features/windowWidth/windowWidth";
import { updateID } from "./features/id/id";
import { updateLogin } from "./features/login/login";
import { updateGoogleLogin } from "./features/googleLogin/googleLogin";
import { updateName } from "./features/name/name";
import "bootstrap/dist/css/bootstrap.min.css";
import ChiChat from "./page/ChiChat/ChiChat";
import NewCourse from './page/NewCourse/NewCourse';
import ProfessorDepartment from "./page/NewComment/ProfessorDepartment";
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

export default function App() {
  const [searchKeyword, setSearchKeyword] = useState("");
  const dispatch = useDispatch();

  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const handleResize = () => {
    dispatch(update(window.innerWidth));
  };

  // const getUserInfo = async () => {
  //   try {
  //     const response = await fetch(process.env.REACT_APP_API_URL + '/oauth/me', {
  //       method: 'POST',
  //       credentials: 'include'
  //     }).then(res => res.json())
  //     dispatch(updateID(response.student_id));
  //     dispatch(updateName(response.name));
  //     dispatch(updateLogin(true));
  //   } catch {
  //     dispatch(updateID(''));
  //     dispatch(updateName(''));
  //     dispatch(updateLogin(false));
  //   }
  // }
  const getUserInfo = async () => {
    // console.log("e3");
    try {
      const res = await fetch(process.env.REACT_APP_API_URL + '/oauth/me', {
        method: 'POST',
        credentials: 'include'
      });

      if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
      }

      const response = await res.json();

      dispatch(updateID(response.student_id || ''));
      dispatch(updateName(response.name || ''));
      dispatch(updateLogin(true));
      dispatch(updateGoogleLogin(false));
    } catch (error) {
      console.error("getUserInfo failed:", error);
      dispatch(updateID(''));
      dispatch(updateName(''));
      dispatch(updateLogin(false));
      dispatch(updateGoogleLogin(false));
    }
  };
  // for google 
  const getGoogleUserInfo = async () => {
    // console.log("google");
    try {
      const token = localStorage.getItem('googleToken'); 
      
      console.log("Token from localStorage:", token);
      
      if (!token) {
        console.log("No token found");
        dispatch(updateGoogleLogin(false));
        dispatch(updateLogin(false));
        return;
      }

      const response = await fetch(process.env.REACT_APP_API_URL + '/oauth/me', {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }).then(res => {
        if (!res.ok) {
          throw new Error(`HTTP error! status: ${res.status}`);
        }
        return res.json();
      })
      console.log("Google user info response:", response);
      dispatch(updateID(response.student_id || ''));
      dispatch(updateName(response.name || ''));
      dispatch(updateGoogleLogin(true));
      dispatch(updateLogin(true));
    } catch (error) {
      console.error("Google login failed:", error);
      localStorage.removeItem('googleToken');
      dispatch(updateGoogleLogin(false));
      dispatch(updateLogin(false));
      // show error message to user if needed
    }
  }

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    const error = params.get('error');

    if (token) {
      localStorage.setItem('googleToken', token);
      localStorage.removeItem('guestMode');
      window.history.replaceState({}, document.title, window.location.pathname);
      getGoogleUserInfo();
      return;
    }
    // if (error) {
    //   localStorage.removeItem('googleToken');
    //   window.history.replaceState({}, document.title, window.location.pathname);
    //   dispatch(updateLogin(false));
    //   dispatch(updateGoogleLogin(false));
    //   return;
    // }
    if (error) {
      localStorage.removeItem('googleToken');
      dispatch(updateLogin(false));
      dispatch(updateGoogleLogin(false));

      if (error === 'domain_not_allowed') {
        setErrorMsg('請使用 @nycu.edu.tw 或 @nctu.edu.tw 結尾的帳號登入');
      } else {
        setErrorMsg('Google 登入失敗，請再試一次');
      }

      setShowErrorModal(true);
      window.history.replaceState({}, document.title, window.location.pathname);
      return;
    }

    const isGuest = localStorage.getItem('guestMode') === 'true';
    if (isGuest) {
      dispatch(updateLogin(false));
      dispatch(updateGoogleLogin(false));
      dispatch(updateID(''));
      dispatch(updateName(''));
      return;
    }

    const googleToken = localStorage.getItem('googleToken');
    if (googleToken) {
      getGoogleUserInfo();
    } else {
      getUserInfo();
    }
  }, [])

  useLayoutEffect(() => {
    // Add event listener to update windowWidth on resize
    window.addEventListener('resize', handleResize);
  
    handleResize();
  
    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Welcome />} />
        <Route path="/home" element={<Home setSearchKeyword={setSearchKeyword} />} />
        <Route path="/comment" element={<Comment searchKeyword={searchKeyword} />} />
        <Route path="/chichat" element={<ChiChat />} />
        <Route path="/new" element={<NewComment />} />
        <Route path="/my-comment" element={<MyComment />} />
        {<Route path="/professor/comment" element={<ProfessorComment />} />}
        {<Route path="/professor/new" element={<ProfessorNewComment />} />}
        {<Route path="/professor/my-comment" element={<ProfessorMyComment />} />}
        <Route path="/reflection" element={<Reflection />} />
        {/*<Route path="/new-course" element={<NewCourse />} />*/}
      </Routes>
      <Modal show={showErrorModal} onHide={() => setShowErrorModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>登入失敗</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {errorMsg}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowErrorModal(false)}>
            關閉
          </Button>
        </Modal.Footer>
      </Modal>
    </Router>
  );
}
